import { render } from "./Links.vue?vue&type=template&id=2bde4856"
import script from "./Links.vue?vue&type=script&lang=ts"
export * from "./Links.vue?vue&type=script&lang=ts"
script.render = render

export default script